


const header = document.querySelector('.header-wrapper');
const menuitem = document.querySelector('.header__menu-wrap');


window.addEventListener("load",function(){
    header.classList.remove('header-wrapper__clear-loading');
},false);

const observer = new IntersectionObserver(
  ([e]) => e.target.classList.toggle('is-sticky', e.intersectionRatio < 1),
  {threshold: [1]}
);

observer.observe(header)

menuitem.addEventListener("mouseover",function() {
    header.classList.add('header-wrapper__clear-hover');
},false);

menuitem.addEventListener("mouseout", function() {
    header.classList.remove('header-wrapper__clear-hover');
}, false);

// VIDEOS

const allFeaturedVideos = document.querySelectorAll('.js-video-container');

for (const videoSection of allFeaturedVideos) {
    const thisVideo = videoSection.querySelector('.js-video');
    const playBtn = videoSection.querySelector('[data-behavior="play-video"]');
    const pauseBtn = videoSection.querySelector('[data-behavior="pause-video"]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    // Do not 'autoplay' videos if not enabled, or if user has reduced motion preference selected
    if (reducedMotion.matches || !thisVideo.hasAttribute('data-autoplay')) {
        playBtn.classList.remove('hidden');
        pauseBtn.classList.add('hidden');
    } else {
        // Rather than adding 'autoplay' attribute to <video> elements, wait until section loads to play
        // Note: using video playback promise https://developers.google.com/web/updates/2017/06/play-request-was-interrupted
        thisVideo.load();
        let playPromise = thisVideo.play();

        if (playPromise !== undefined) {
            playPromise.then(() => {
                playBtn.classList.add('hidden');
                pauseBtn.classList.remove('hidden');
            })
            .catch(error => {
              console.log(playBtn);
                playBtn.classList.remove('hidden');
                pauseBtn.classList.add('hidden');
                console.log('Error playing video');
            });
        }
    }

    playBtn.addEventListener('click', event => {
        thisVideo.play();
        playBtn.classList.add('hidden');
        pauseBtn.classList.remove('hidden');
    });

    pauseBtn.addEventListener('click', event => {
        thisVideo.pause();
        playBtn.classList.remove('hidden');
        pauseBtn.classList.add('hidden');
    });
}
